<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import EditButtonView from "../../../../component/common/Button/EditButtonView.svelte";
    import {AppAccessTokenTable} from "../../../../lib/Table/AppAccessTokenTable";
    import CreatedUpdatedView from "../../../../component/common/Value/CreatedUpdatedView.svelte";
    import DisplayValueView from "../../../../component/common/Value/DisplayValueView.svelte";

    const dispatcher = createEventDispatcher();

    export let appAccessToken;

    onMount(() => {
    });

    function onClickEdit(event) {
        console.log({appAccessToken});
        dispatcher('edit', {appAccessToken: appAccessToken});
    }

</script>

<tr class="app-access-token-view">
    <td>
        <EditButtonView on:click={onClickEdit}/>

    </td>
    <td>
        { appAccessToken.name }
    </td>
    <td>
        { AppAccessTokenTable.Type.map[appAccessToken.type] }
    </td>
    <td>
        { appAccessToken.access_token }
    </td>
    <td>
        <DisplayValueView value={ appAccessToken.expire_at }/>
    </td>
    <td class="number">
        { appAccessToken.use_count }
    </td>
    <td class="latest-use">
        <div>
            {#if appAccessToken.latest_use_ip != null}
                { appAccessToken.latest_use_ip }
            {/if}
        </div>
        <div class="latest-use-at">
            {#if appAccessToken.latest_use_at != null}
                { appAccessToken.latest_use_at }
            {/if}
        </div>
    </td>
    <td class="created-updated-cell">
        <CreatedUpdatedView model={appAccessToken} isShowUser={false}/>
    </td>


</tr>
<style lang="scss">
    .app-access-token-view {
        td {
            &.latest-use {
                .latest-use-at {
                    font-size: 0.5em;
                    white-space: nowrap;
                }
            }

            &.created-updated-cell {
                font-size: 0.5em;
                opacity: 0.5;
            }
        }

    }
</style>